import { registerPlugin } from '@capacitor/core';

import type { QRScannerPlugin } from './definitions';

const QRScanner = registerPlugin<QRScannerPlugin>('QRScanner', {
  web: () => import('./web').then((m) => new m.QRScannerWeb()),
});

export * from './definitions';
export { QRScanner };
